import { render } from "./ActivityStatement.vue?vue&type=template&id=00b27591"
import script from "./ActivityStatement.vue?vue&type=script&lang=js"
export * from "./ActivityStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__